import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import invokeApi from '../network';
import networkConfig from '../network/config';
import { CREATE_ORDER, CREATE_ORDER_FAILURE, CREATE_ORDER_SUCCESS, GET_ORDERS, GET_ORDERS_SUCCESS, GET_ORDERS_FAILURE, GET_PAST_ORDER, GET_PAST_ORDER_SUCCESS, GET_PAST_ORDER_FAILURE, UPDATE_CUSTOMER_ID_ORDER, UPDATE_CUSTOMER_ID_ORDER_FAILURE, UPDATE_CUSTOMER_ID_ORDER_SUCCESS, VALIDATE_ORDER_SUCCESS, VALIDATE_ORDER_FAILURE, VALIDATE_ORDER_REQUEST, FULL_STORY_SESSION } from '../constants';
import AuthManager from '../auth/AuthManager';
import { setErrorCode } from '../redux/Actions/ErrorAction';
const { getInstance: auth } = AuthManager;
export function* createOrder(data) {
    try {
        const { payload } = data;
        const { tenantId = '', request = null, customerId, successCallback = null, errorCallback = null } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': auth().isMember,
            'x-user-id': customerId,
        };
        const { response, status } = yield call(invokeApi, _.get(networkConfig, 'createOrder'), null, headers, request);
        if (status > 400) {
            yield put(setErrorCode(status));
        }
        const isValidResponse = response && response.order?.id && response.basketValidationResult?.overAll?.status;
        if (isValidResponse) {
            const { order = {} } = response;
            const { id: orderId = '' } = order;
            yield put({
                type: CREATE_ORDER_SUCCESS,
                response,
            });
            successCallback?.(orderId);
        }
        else {
            yield put({
                type: CREATE_ORDER_FAILURE,
                response,
            });
            errorCallback?.(response);
        }
    }
    catch (error) {
        yield put({
            type: CREATE_ORDER_FAILURE,
            response: error,
        });
    }
}
export function* createOrderSaga() {
    yield takeLatest(CREATE_ORDER, createOrder);
}
export function* getOrders(data) {
    try {
        const { payload } = data;
        const { tenantId = '', orderId = '' } = payload;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.getOrder, {
            queryProps: {
                orderId,
            },
        }, headers);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: GET_ORDERS_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: GET_ORDERS_FAILURE,
                response,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_ORDERS_FAILURE,
            response: error,
        });
    }
}
export function* getOrdersSaga() {
    yield takeLatest(GET_ORDERS, getOrders);
}
export function* getPastOrder(data) {
    try {
        const { payload } = data;
        const { tenantId = '', orderNo = '', emailId = '', phoneNo = '' } = payload;
        const postBody = {
            email: emailId,
            phoneNumber: phoneNo,
            posOrderId: orderNo,
        };
        const headers = {
            'x-tenant-id': tenantId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.getPastOrder, null, headers, postBody);
        if (status === 200) {
            if (response) {
                yield put({
                    type: GET_PAST_ORDER_SUCCESS,
                    response,
                });
            }
            else {
                yield put({
                    type: GET_PAST_ORDER_FAILURE,
                    response,
                });
            }
        }
        else {
            yield put({
                type: GET_PAST_ORDER_FAILURE,
                response,
            });
        }
    }
    catch (error) {
        yield put({
            type: GET_PAST_ORDER_FAILURE,
            response: error,
        });
    }
}
export function* getPastOrderSaga() {
    yield takeLatest(GET_PAST_ORDER, getPastOrder);
}
export function* updateCustomerIDforOrder(request) {
    try {
        const { payload } = request;
        const tenantId = payload?.tenantId;
        const headers = {
            'x-tenant-id': tenantId,
        };
        const postBody = {
            id: payload.customerId,
        };
        const { response, status } = yield call(invokeApi, networkConfig.updateCustomerIDforOrder, { queryProps: { orderId: payload.orderId } }, headers, postBody);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        if (response) {
            yield put({
                type: UPDATE_CUSTOMER_ID_ORDER_SUCCESS,
                response,
            });
        }
        else {
            yield put({
                type: UPDATE_CUSTOMER_ID_ORDER_FAILURE,
            });
        }
    }
    catch (error) {
        yield put({
            type: UPDATE_CUSTOMER_ID_ORDER_FAILURE,
        });
    }
}
export function* updateCustomerIDforOrderSaga() {
    yield takeLatest(UPDATE_CUSTOMER_ID_ORDER, updateCustomerIDforOrder);
}
export function* validateOrder(requestData) {
    try {
        const { payload } = requestData;
        const { tenantId = '', request = null, customerId, successCallback = null, fullStorySessionUrl, errorCallback = null, } = payload;
        const headers = {
            'x-tenant-id': tenantId,
            'x-is-registered-user': auth().isMember,
            'x-user-id': customerId,
        };
        if (fullStorySessionUrl) {
            request.customProperties = [
                {
                    key: FULL_STORY_SESSION,
                    value: fullStorySessionUrl,
                },
            ];
        }
        const newNetwork = {
            ...networkConfig.validateOrder,
            ...payload,
        };
        const { response, status } = yield call(invokeApi, newNetwork, null, headers, request);
        if (status >= 400) {
            yield put(setErrorCode(status));
        }
        const isOverallValidationStatus = response && response.order?.id && response.basketValidationResult?.overAll?.status;
        const message = response && response.order?.id && response.basketValidationResult?.overAll?.message;
        if (isOverallValidationStatus) {
            yield put({
                type: VALIDATE_ORDER_SUCCESS,
                response,
            });
            successCallback && successCallback(response);
        }
        else {
            yield put({
                type: VALIDATE_ORDER_FAILURE,
                response,
            });
            errorCallback && errorCallback();
        }
    }
    catch (error) {
        yield put({
            type: VALIDATE_ORDER_FAILURE,
            response: error,
        });
    }
}
export function* validateOrderSaga() {
    yield takeLatest(VALIDATE_ORDER_REQUEST, validateOrder);
}
